import { authClient } from "@/frontend/lib/auth";

interface SwitchOrganizationParams {
  organizationId: string;
  setCurrentOrg: (orgId: string) => void;
}

export async function setActiveOrganization(organizationId: string): Promise<void> {
  const response = await authClient.organization.setActive({ organizationId });
  if (response?.error) {
    throw new Error(response.error.message || "Failed to switch organization");
  }
}

export async function switchOrganization({
  organizationId,
  setCurrentOrg,
}: SwitchOrganizationParams): Promise<void> {
  await setActiveOrganization(organizationId);
  setCurrentOrg(organizationId);
}
